import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const AltArrowDown: FC<Props> = (props) => {
  const { fill, ...customProp } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      {...customProp}
      fill="none"
      aria-label="alt arrow down icon"
    >
      <path
        d="M15.8334 7.5L10.0001 12.5L4.16675 7.5"
        stroke={fill || "currentColor" || "#52565C"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AltArrowDown;
